/**
 * There is a bug in iOS 16 and below where the line clamp feature in
 * CSS is broken. This causes problems with our existing card design
 * on those devices.
 *
 * Source: https://stackoverflow.com/questions/70679732/css-line-clamp-does-not-work-in-safari-on-inner-block-level-elements/
 *
 * This helper function will take those paragraphs and manually rewrite
 * them using JS to ensure they are only a certain length in order to
 * try and replicate what the CSS was originally meant to do.
 *
 * @param {number} maxLength - How many characters should be displayed in total for the card description.
 */
export function iOSCardFix(maxLength = 80) {
    if (isOffendingBrowser()) {
        // Get all the relevant card descriptions
        const cardDescriptions = document.querySelectorAll(".content-card__description p");
        cardDescriptions.forEach((text) => {
            if (text.innerHTML.length > maxLength) {
                text.innerHTML = text.innerHTML.substring(0, maxLength - 3) + '...';
            }
        });
        console.info('Manually updating card description length to fix iOS bug');
    }
}
/**
 * A simple function to determine if the browser require special treatment
 *
 * @returns {boolean}
 */
function isOffendingBrowser() {
    const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const ver16 = /Version\/16/.test(navigator.userAgent);
    const ver15 = /Version\/15/.test(navigator.userAgent);
    return iOS && (ver16 || ver15);
}
//# sourceMappingURL=ios-cards-fix.js.map